/*
 * Title: Touchpoints/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import MobileHead, Touchpoints items from components.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React from "react";
import { connect } from "react-redux";
import "./index.css";
import MobileHead from "@components/Touchpoints/MobileHead";
import LinkTo from "@components/LinkTo";
import NotificationService from "@services/notification-service";
import creatorTouchpoints from "@common/touchpoints.json";
import CreatorTouchpoint from "@components/CreatorTouchpoints/Touchpoint";


type Props = {
  new_user_flag: boolean;
  addNewUserFlag: (flag: boolean) => void;
  form: Object;
  featured: string;
  id: any;
};
type MyState = {
  name_error: boolean;
  formId_error: boolean;
  new_add_form: boolean;
  edit_form: boolean;
  enabled: boolean;
  [key: string]: any;
  a: boolean;
};

const featured = "featured";
const actionItem = "refer";


class Touchpoints extends React.Component<Props | any, MyState> {
  state: MyState = {
    name_error: false,
    formId_error: false,
    new_add_form: false,
    edit_form: false,
    enabled: false,
    a: false,
    checked: true,
    points: false,
  };

  componentDidMount() {
    //this.props.fetch(this.props.user?.user?.user?.id);
    this.props.clearForm();
    const timer = setTimeout(() => {
      this.props.addNewUserFlag(false);
    }, 3000);
    return () => clearTimeout(timer);
  }

  applyHandle = async () => {
    let form = Object.assign({}, this.props.form);
    form = {
      ...form,
      points: 250,
    };
    const json = await this.props.submit({ touchpointData: form });
    if (json !== undefined) {
      if (json.status === 200) {
        NotificationService.success("Touchpoint added successfully.");
        this.setState({ new_add_form: false });
      }
    }
  };
  addForm = (key: any, value: any) => {
    const form = Object.assign({}, this.props.form);
    form[key] = value;
    this.props.addForm(form);
  };

  handleNameChange = e => {
    if (e.target.value.length <= 11) {
      this.setState({
        name_error: true,
      });
    } else {
      this.setState({
        name_error: false,
      });
    }
  };

  handleFormID = e => {
    if (e.target.value.length <= 11) {
      this.setState({
        formId_error: true,
      });
    } else {
      this.setState({
        formId_error: false,
      });
    }
  };
  cancelForm = () => {
    this.setState(
      { new_add_form: false, title: false, typeformId: false, url: false },
      () => {
        this.props.clearForm();
      }
    );
  };

  deleteTypeForm = data => {
    this.props.delete(data);
  };

  editTypeForm = data => {
    data = {
      ...data,
      typeformId: data.id,
    };
    const form = data;

    this.props.addForm(form);
  };

  newTypeForm = () => {
    this.setState({ new_add_form: true }, () => {
      this.props.clearForm();
    });
  };

  updateTypeForm = () => {
    const form = Object.assign({}, this.props.form);
    this.props.update(form);
  };

  validation = () => {
    const regex = new RegExp(
      /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gi
    );
    let flag = true;
    let array = ["title", "typeformId", "url"];
    let form = Object.assign({}, this.props.form);
    array.map((item, key) => {
      if (!Object.keys(form).some(index => index === item)) {
        this.setState({ [item]: true });
        flag = false;
      }
    });
    Object.keys(form).map(item => {
      if (array.some(index => index === item)) {
        if (
          form[item] === null ||
          form[item] === "null" ||
          form[item] === "" ||
          form[item].length === 0
        ) {
          this.setState({ [item]: true });
          flag = false;
        } else {
          if (item === "url") {
            if (!regex.test(form[item])) {
              flag = false;
              this.setState({ [item]: true });
            } else {
              this.setState({ [item]: false });
            }
          } else {
            this.setState({ [item]: false });
          }
        }
      }
    });

    if (flag) {
      if (form.id) {
        this.updateTypeForm();
      } else {
        this.applyHandle();
      }
    }
  };

  fanReferralsHandle = async (id, e) => {
    if (e) {
      const json = await this.props.fanReferrals(featured, actionItem);
      if (200 === json.status) {
        this.props.fetch(this.props.user?.user?.user?.creatorId);
      }
    } else {
      const json = await this.props.fanReferralsDeactivate(id);
      if (200 === json.status) {
        this.props.fetch(this.props.user?.user?.user?.creatorId);
      }
    }
  };

  handleEmailToggle = () => {
    this.props.emailToggle();
  }
  handlePlayerToggle = () => {
    this.props.playerToggle();
  }
  handleTeamToggle = () => {
    this.props.teamToggle();
  }
  handleSportToggle = () => {
    this.props.sportToggle();
  }

  render() {
    const { user } = this.props;
    return (
      <>
        <MobileHead title={"Touchpoints"} />
        <div id="darkscrollbar" className="bg-[#F6F2E9] lg:h-[calc(100vh-80px)] h-[calc(100vh-90px)] w-full overflow-y-auto overflow-x-hidden">
          <div className="container mx-auto px-[25px]">
            <div className="max-w-[1120px] mx-auto">
              <div
                className="pt-[40px] overflow-hidden pr-1 lg:-mr-0 -mr-2 pb-[30px]"
              >
                <LinkTo
                  to="/settings"
                  className="mb-[40px] leading-[21.2px] text-[black]/70 hover:c-primary max-w-[160px] w-full block text-[18px] font-normal"
                  text="< Back to settings"
                />
                <div className="bg-[#FBFAF6] rounded-xl p-[30px_20px]">
                {creatorTouchpoints.map((item, index)=>(
                  <CreatorTouchpoint key={index} item={item} />
                ))}
                </div>
        
                
              </div>
            </div>
          </div>
        </div>
        {/* {this.props.new_user_flag && <Joined />} */}
      </>
    );
  }
}
const mapStateToProps = ({ user, score, creator }) => {
  return {
    assets: creator.assets,
    score: score,
    new_user_flag: user.new_user_flag,
    points_redeemed: score.points_redeemed,
    user: user,
    form: creator.form,
    loading: creator.isSubmitting,
    error: creator.error,
    data: creator.typeForm.data,
    isFetching: creator.typeForm.isFetching,
    touchpoints: creator.creatorstouchpoint,
    emailSwitch: creator.emailSwitch,
    playerSwitch: creator.playerSwitch,
    teamSwitch: creator.teamSwitch,
    sportSwitch: creator.sportSwitch,
  };
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
  const { dispatch } = dispatchProps;
  const { actions } = require("@redux/UserRedux");
  const { actions: acreator } = require("@redux/CreatorRedux");
  return {
    ...stateProps,
    addNewUserFlag: (flag: boolean) => {
      dispatch(actions.addNewUserFlag(flag));
    },
    submit: data => {
      return acreator.submitTypeForm(dispatch, data);
    },
    fetch: data => {
      acreator.fetchTypeForm(dispatch, data);
    },
    fanReferrals: (touchpoint, actionItem) => {
      return acreator.fanReferrals(dispatch, touchpoint, actionItem);
    },
    fanReferralsDeactivate: actionItemId => {
      return acreator.fanReferralsDeactivate(dispatch, actionItemId);
    },
    delete: data => {
      acreator.deleteTypeForm(dispatch, data);
    },
    update: data => {
      acreator.updateTypeForm(dispatch, data);
    },
    addForm: (form: Object) => {
      dispatch(acreator.addForm(form));
    },
    clearForm: () => {
      dispatch(acreator.clearForm());
    },


    emailToggle: () => {
      dispatch(acreator.emailSwitch());
    },
    playerToggle: () => {
      dispatch(acreator.playerSwitch());
    },
    teamToggle: () => {
      dispatch(acreator.teamSwitch());
    },
    sportToggle: () => {
      dispatch(acreator.sportSwitch());
    },
  };
};

export default connect(mapStateToProps, undefined, mergeProps)(Touchpoints);
